<template>
  <h-list-page class="log-container">
    <h-card title="筛选条件" width="100%" is-search @change-method="changeMethod">
      <h-area title-width="90px" :all-span="7">
        <h-search title="供应商代码">
          <h-input v-model.trim="searchData.supplierNo" clearable></h-input>
        </h-search>
        <h-search title="供应商名称">
          <h-input v-model.trim="searchData.supplierName" clearable></h-input>
        </h-search>
        <h-search title="登录账号">
          <h-input v-model.trim="searchData.userName" clearable></h-input>
        </h-search>
        <h-search title="登录类型">
          <h-select v-model="searchData.userSource" clearable filterable @change="handleSource">
            <template v-for="item in sourceList" :key="item.value">
              <h-option :label="item.label" :value="item.value"></h-option>
            </template>
          </h-select>
        </h-search>
        <h-search title="登录时间">
          <h-date-picker v-model="loginTime" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间" clearable/>
        </h-search>
        <template #operate>
          <div class="flex-end">
            <h-button type="primary" :loading="tableLoading" @click="handleSearch">
              <template #icon><search /></template>查询
            </h-button>
          </div>
        </template>
      </h-area>
    </h-card>
    <h-table-card title="登录日志">
      <template #buttonGroup>
        <h-button-group>
          <!-- v-if="permissions.includes('S01053_HMQM_BLGL_BLBA_DC')" -->
          <h-button type="primary" :loading="exportLoading" @click="handleExport">
            <template #icon><i class="iconfont icon-daochu"></i></template>导出
          </h-button>
        </h-button-group>
      </template>
      <el-table empty-text="暂无数据" v-loading="tableLoading"
        border :data="tableData" height="520"
        size="small" style="width: 100%; min-height: 520px"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="supplierNo" label="供应商代码" width="120"></el-table-column>
        <el-table-column prop="supplierName" label="供应商名称" min-width="260"></el-table-column>
        <el-table-column prop="userName" label="登录账号" width="200"></el-table-column>
        <el-table-column prop="roleName" label="登录人角色" width="100"></el-table-column>
        <el-table-column prop="loginTime" label="登录时间" width="220"></el-table-column>
        <el-table-column label="登录类型">
          <template #default="{ row }">
            <span>{{ row.userSource == 1 ? '老海达源' : row.userSource == 2? '新海达源' : row.userSource == 3 ? '旧版用户' : ''}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @current-change="handlePageChange"
        v-model:currentPage="currentPage" :page-size="10" style="display: flex;flex-direction: row;justify-content: flex-end;margin-right: 55px"
        layout="total, prev, pager, next,jumper" :total="total">
      </el-pagination>
    </h-table-card>
  </h-list-page>
</template>

<script>
import moment from 'moment'
export default {
  data(){
    return{
      searchData:{},
      currentPage:1,
      tableLoading: false,
      tableData:[],
      total:0,
      rowListOfCheck:[], // 选中的行
      loginTime:[],
      // 1-老海达源，2-新海达源，3-旧版用户
      sourceList:[{
        label:'旧版用户',
        value:'3'
      },{
        label:'老海达源',
        value:'1'
      },{
        label:'新海达源',
        value:'2'
      }]
    }
  },
  methods:{
    handleSearch(){
      this.currentPage = 1
      this.getTableList()
    },
    getTableList(){
      this.tableLoading = true
      let params = this.searchData
      if(this.loginTime&&this.loginTime.length>0){
        params.beginDateOne = moment(this.loginTime[0]).format('YYYY-MM-DD 00:00:00') 
        params.endDateOne = moment(this.loginTime[1]).format('YYYY-MM-DD 23:59:59')
      }else{
        delete params.beginDateOne
        delete params.endDateOne
      }
      this.$http({
        method: "post",
        url: "/base/userLoginLog/list",
        headers: { "content-type": "application/json" },
        data: {
          ...this.searchData,
          current: this.currentPage,
          size: 10,
        },
      }).then((res) => {
        this.tableLoading = false
        this.tableData = []
        if(res.data.code==0){
          if(res&&res.data&&res.data.data&&res.data.data.records&&res.data.data.records.length>0){
            let tmpList = [...res.data.data.records]
            tmpList.forEach(item =>{
              item.loginTime = item.loginTime ? moment(item.loginTime).format('YYYY-MM-DD HH:mm:ss') : ''
              this.tableData.push(item)
            })
          }else{
            this.tableData = []
          }
          this.total = res.data.data.total
        }
      }).catch(err => {
        this.tableLoading = false
        console.log(err)
      })  
    },
    handlePageChange(val){
      if(val){
        this.current = val
      }else{
        this.current = 1
      }
      this.getTableList()
    },
    handleSelectionChange(val){
      this.rowListOfCheck = [...val]
    },
    // 导出
    handleExport(){
      this.exportLoading = true;
      this.startLoading("日志列表导出中...");
      this.httpFile(
        {
          method: "post",
          url: "/base/userLoginLog/userLoginListExport",
          data: {
            ...this.searchData,
            current: this.currentPage,
            size: 10,
          },
        },
        "日志列表.xlsx"
      ).then(res=>{
        this.exportLoading = false;
        this.closeLoading();
      }).catch(err=>{
        this.exportLoading = false;
        this.closeLoading()
      })
    },
    handleSource(val){
      if(val){
        this.searchData.userSource = val
      }else{
        delete this.searchData.userSource
      }
    }
  },
  mounted(){
    this.getTableList()
  }
}
</script>

<style scoped>
.click-btn{
  color: #3a8ee6;
  cursor: pointer;
}
.is-hwork{
  width: 98%;
  min-width: 98%;
  box-sizing: border-box;
}
.is-hwork .haier-input-9 .el-input__inner{
  padding-left: 115px;
}
.is-hwork .el-table th{
  background: #F1F2F8 !important;
  color: #1D2129 !important;
  font-size: 14px;
}
.haier-list-page .el-table .cell{
  padding-left: 14px !important;
}
body .el-table .cell{
  text-align: left;
}
.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
  border-right: none;
}
</style>
<style lang="scss" scoped>
.log-container{
  height: 100%;
  padding: 0;
  margin: 0px auto;
  border-radius: 8px;
  box-sizing: border-box;
}
</style>